import React from 'react';
import PropTypes from 'prop-types';

const ListItem = ({
  selected,
  id,
  memriUserId,
  dmaDesc,
  displayMemriUser,
  handleSelection,
  propCode,
  propCodeDescription,
}) => {
  const handleItemSelection = event => {
    event.preventDefault();
    const selectedElementId = event.currentTarget.id
      ? event.currentTarget.id
      : event.currentTarget.memriUserId;
    let clearExisting = true;
    let shiftKey = false;
    if (event.ctrlKey) {
      clearExisting = false;
    }
    if (event.shiftKey) {
      shiftKey = true;
    }
    handleSelection(selectedElementId, clearExisting, shiftKey);
  };

  if (displayMemriUser || propCode) {
    return (
      <li
        onMouseDown={handleItemSelection}
        id={id ? id : memriUserId}
        className={selected ? 'active' : ''}
      >
        <a>
          <span className="menu-text">
            {displayMemriUser
              ? displayMemriUser
              : `${propCodeDescription}(${propCode})`}
          </span>
        </a>
      </li>
    );
  }
  return (
    <li
      onMouseDown={handleItemSelection}
      id={id}
      className={selected ? 'active' : ''}
    >
      <a>
        <span className="menu-text">{dmaDesc}</span>
      </a>
    </li>
  );
};

ListItem.propTypes = {};

export default ListItem;
